import React from "react";
import TerminalActionButton from "../../UI/TerminalActionButton/TerminalActionButton";
import CssClasses from "./AdminSideMenu.css";
import { connect } from "react-redux";
import * as StoreActions from "../../../ReduxStore/Actions/ActionIndex";

import * as UserPermissionIDs from "../../../HOCs/Constants/UserPermissionIDs";

let _props = null;
let _buttonTypes = null;

const AdminSideMenu = props => {
  _props = props;

  const buttonTypes = [
    {
      id: 1,
      icon: "admin_dashboard",
      title: "Nadzorna ploča",
      screenID: 1
    },
    {
      id: 2,
      icon: "admin_balance",
      title: "Saldo terminala",
      screenID: 2
    },
    {
      id: 3,
      icon: "admin_cash_flow",
      title: "Promet novčanica",
      screenID: 3
    },
    {
      id: 4,
      icon: "admin_transactions",
      title: "Povijest transakcija",
      screenID: 4
    },
    {
      id: 5,
      icon: "admin_tickets",
      title: "Pregled tiketa",
      screenID: 5
    },
    {
      id: 6,
      icon: "admin_search",
      title: "Pronađi tiket",
      screenID: 6
    },
    {
      id: 7,
      icon: "admin_invoice",
      title: "Potvrde za djelomičnu isplatu",
      screenID: 7
    },
    {
      id: 8,
      icon: "admin_log",
      title: "Zapisnik događaja",
      screenID: 8
    },
    {
      id: 9,
      icon: "admin_qr",
      title: "Izrada QR kodova",
      screenID: 9
    },
    {
      id: 10,
      icon: "admin_settings",
      title: "Postavke",
      screenID: 10
    },
    {
      id: 100,
      icon: "admin_logout",
      title: "Odjava i izlaz",
      screenID: 100
    }
  ];

  _buttonTypes = buttonTypes;

  return (
    <div className={CssClasses.container}>
      {buttonTypes.map(btn => {
        if (
          btn.id !== 100 && //logout
          props.adminInfo.PermissionList &&
          !props.adminInfo.PermissionList.includes(
            getPermissionIDForButtonID(btn.id)
          )
        ) {
          return null;
        }
        return (
          <TerminalActionButton
            icon={btn.icon}
            onButtonClicked={specialOptionButtonClick}
            title={btn.title}
            key={btn.id}
            id={btn.id}
            isActive={btn.screenID === props.currentAdminScreenID}
            isLogoutButton={btn.id === 100}
          />
        );
      })}
    </div>
  );
};

const getPermissionIDForButtonID = btnID => {
  switch (btnID) {
    case 1:
      return UserPermissionIDs.ADMIN_SCREEN_DASHBOARD;
    case 2:
      return UserPermissionIDs.ADMIN_SCREEN_TERMINAL_BALANCE;
    case 3:
      return UserPermissionIDs.ADMIN_SCREEN_BILL_FLOW;
    case 4:
      return UserPermissionIDs.ADMIN_SCREEN_TRANSACTION_HISTORY;
    case 5:
      return UserPermissionIDs.ADMIN_SCREEN_TICKET_OVERVIEW;
    case 6:
      return UserPermissionIDs.ADMIN_SCREEN_FIND_TICKET;
    case 7:
      return UserPermissionIDs.ADMIN_SCREEN_PARTIAL_PAYOUT_RECEIPTS;
    case 8:
      return UserPermissionIDs.ADMIN_SCREEN_EVENT_LOG;
    case 9:
      return UserPermissionIDs.ADMIN_SCREEN_QR_CODES;
    case 10:
      return UserPermissionIDs.ADMIN_SCREEN_PREFERENCES;
    default:
      return 0;
  }
};

const specialOptionButtonClick = id => {
  console.log("Button click.." + id);

  //nadji screenid
  let btnInfo = _buttonTypes.find(x => x.id === id);

  let screenID = btnInfo.screenID;

  if (id === 100) {
    //okini logout
    //alert("Odjava...");
    window.cefCustomObject.changeAdminLoginState(false);
    _props.stopLoading(true);
    _props.logoutAdmin();
    return;
  }

  if (screenID === _props.currentAdminScreenID) {
    //gasi
    //_props.setCurrentScreenID(0);  --zasad nema gasenja ipak
  } else {
    //prebaci
    _props.setCurrentScreenID(screenID);
  }

  //_props.onChangeServerStatus(id);
  // if (id === 4) {
  //   _props.onChangeServerStatus(200);
  // } else {
  //   _props.onChangeServerStatus(id);
  // }
};

const mapStateToProps = state => {
  return {
    currentAdminScreenID: state.rrNavigation.currentAdminScreenID,
    adminInfo: state.rrNavigation.adminInfo
  };
};

const mapDispatchToProps = dispatch => {
  return {
    stopLoading: updateStorage =>
      dispatch(StoreActions.StopLoading(updateStorage)),
    setCurrentScreenID: screenID =>
      dispatch(StoreActions.ChangeCurrentAdminScreen(screenID)),
    logoutAdmin: () => dispatch(StoreActions.SetAdminInfo(null))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminSideMenu);



// WEBPACK FOOTER //
// ./src/Components/Navigation/AdminSideMenu/AdminSideMenu.js